import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { NuxContainer } from 'us-react-components/dist/NuxContainer/NuxContainer';
import { useDependencies } from '../../../dependencies';
import { Routes } from '../../../Routes';
import identityCard from '../../../images/animations/identity_card.json';
import { LottieComponent, LottieComponentProps } from '../../../types/LottieComponent';

export const Fantastic: LottieComponent<LottieComponentProps> = observer((props: LottieComponentProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { useLottie } = props;
  const { stores: { familyRegistration }, services: { tracker } } = useDependencies();

  familyRegistration.setCurrentRoute(Routes.parent.registration.fantastic);


  const handleContinue = (): void => {
    navigate(Routes.parent.registration.photo);
  }

  const options = {
    animationData: identityCard,
    loop: false,
    style: {
      height: '237px',
      width: '237px',
    }
  };

  const { View } = useLottie(options);

  return (
    <NuxContainer
      familyRegistration={familyRegistration}
      navigate={navigate}
      tracker={tracker}
      inverted
      onContinue={handleContinue}
      title={t('pages.nux.family.fantastic.title')}
      continueTitle={t('pages.nux.family.fantastic.button')}
    >
      {View}
    </NuxContainer>
  )
});
